import React from "react";
import "./generic.scss";
import FailIcon from "./img/attention.svg?react"

export default function Fail({children}) {

  return (
    <div className="fail">
      <div className="fail-indicator">
        <FailIcon/>
      </div>
      <div className="fail-content">
        {children}
      </div>
    </div>
  )
}
